export const vueAppSelMode = process.env.production

export default {
    vueAppSelMode
}
